<div class="loader">
  <core-helpers-box-loading [hidden]="status == STATUS_DONE"></core-helpers-box-loading>
</div>
<div *ngIf="status == STATUS_NOT_FOUND">
    <core-layout-error-not-found></core-layout-error-not-found>
</div>


<div class="app-wrapper" *ngIf="status == STATUS_DONE"  [ngClass]="{'with-overlay': showAvatarEditor || showSaved}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="showSaved"
        [type]="'done'"
        [message]="'Profile Saved'"
        [text]="'Your profile has been successfully updated'"
        [buttonText]="'Done'"
        (action)="onSavedDone($event)">
    </core-layout-modal-feedback>
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content profile-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                    <core-title-section
                    [title]="'Profile'"
                    [description]="'Here you can personalise your profile. Add a picture so everyone can easily identify you.'"
                  ></core-title-section>
                </div>
            </header>

              <div class="profile-edit-container box_default box_white" >
                  <div class="profile-avatar" title="Click to edit avatar." (click)="openAvatarEditor()">
                    <figure>
                      <core-avatar-img [user]="user" [size]="80" [onlineIcon]="false"> </core-avatar-img>
                      <span></span>
                    </figure>
                  </div>
                    <form [formGroup]="form">
                      <div class="box_item">
                        <label class="box-label">NAME</label>
                          <input type="text" placeholder="Introduce your name." formControlName="name"/>
                      </div>
                      <div class="box_item">
                        <label class="box-label">EMAIL</label>
                          <input type="text" formControlName="email"/>
                      </div>
                      <div class="box_fieldset">
                        <core-helpers-forms-button-white [text]="'Save'" [disabled]="form.invalid || !formChanged()" (click)= "save()"></core-helpers-forms-button-white>
                        <core-helpers-forms-button-white [hidden]="passwordRequested" [text]="'Reset Password'" (click)="changePassword()"></core-helpers-forms-button-white>
                      </div>
                      <core-helper-box-notification-message
                            [hidden]="!passwordRequested"
                            [message]="'A reset password request was sent to your email.'"
                            ></core-helper-box-notification-message>

                    </form>
              </div>
        </div>
    </section>
    <profile-avatar-main *ngIf="showAvatarEditor" [user]="user" (clickCancel)="closeAvatarEditor()"></profile-avatar-main>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
